export {}

const iframeWrapper = document.querySelector<HTMLElement>(".s-tickets__goout")

if (!iframeWrapper) {
  const tickets = document.querySelectorAll<HTMLElement>(".i-ticket[data-goout-id]")

  tickets?.forEach((ticket) => {
    const button = ticket.querySelector<HTMLElement>(".i-ticket__cta")
    const urlString = button?.getAttribute("href") ?? null
    const url = urlString ? new URL(urlString) : null

    const input = ticket.querySelector<HTMLInputElement>(".c-counter__input")

    input?.addEventListener("change", () => {
      const value = input.value
      url?.searchParams.set("count", value)

      button?.setAttribute("href", url?.toString() ?? "")
    })
  })
}
